import InProgressExportTable from "./InProgressExportTable";

export default InProgressExportTable;
